<script setup>
defineProps({
  element: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});
defineOptions({ inheritAttrs: false });
</script>

<template>
  <div
    :style="{ height: `${element.height}px` }"
    :class="selected ? 'bg-n-brand/10' : 'group-hover/el:bg-n-brand/5'"
  />
</template>
